import { JSX } from "react";
import { ProductDetailInfoBar } from "@hatch-digital-nl/bravilor-storybook";
import { CategoryInterface } from "../../../common/interfaces/CategoryInterface";
import { DstProductDetailViewModel } from "../interfaces/ProductDetailViewTypes";
import { DstProductDetailLabels } from "../utils/productDetailLabels";
import { buildProductBreadcrumbs } from "./ProductDetailsHeader";

interface Props {
    data: DstProductDetailViewModel | undefined;
    productCategories: CategoryInterface[];
    isPageLoading: boolean;
    labels: DstProductDetailLabels;
}

export const ProductDetailsInfoBar = ({
    data,
    productCategories,
    isPageLoading,
    labels,
}: Props): JSX.Element => {
    if (isPageLoading || !data) {
        return (
            <ProductDetailInfoBar
                variant="product-range"
                isLoading
                showButtons={false}
            />
        );
    }

    return (
        <ProductDetailInfoBar
            variant="product-range"
            name={data.label}
            identifier={data.identifier}
            identifierLabel={labels.artNr}
            breadcrumbs={buildProductBreadcrumbs(productCategories, data.label)}
            showButtons={false}
        />
    );
};
